import Random from "./components/Random";
import Tag from "./components/Tag";

export default function App() {
  return (

    <div className="w-full h-screen flex flex-col background relative
    overflow-x-hidden items-center">
      <h1 className="bg-white rounded-md absolute w-11/12
      text-center mt-[40px] px-10 py-2 text-3xl font-bold">Random Gif</h1>
      <div className="flex flex-col w-full items-center gap-y-10 mt-[140px]">
        <Random/>
        <Tag/>
      </div>
    </div>
  
    );
}
